import { BaseDeviceWrapper } from "./BaseDeviceWrapper";
import image from "images/devices/hotoctopuss-promotion.png";

const serviceUuid = "00001900-0000-1000-8000-00805f9b34fb";
const statusCharacteristicUuid = 0x1901;
const characteristicUuid = 0x1902;
const names = ["Pulse Interactive"];

/**
 * Create a device wrapper over the Web Bluetooth device object
 * @param {obj} webBleDevice - Web Bluetooth device object
 */
export default class PulseInteractive extends BaseDeviceWrapper {
  constructor(device) {
    super(device, serviceUuid, characteristicUuid, image);
  }

  static get deviceNames() {
    return names;
  }

  /**
   * Needed to request access to these services before connecting to the device
   */
  static get services() {
    return [serviceUuid];
  }

  get companyName() {
    return "Kiiroo";
  }

  async connect() {
    try {
      await super.connect(this.getBatteryCharacteristic.bind(this));
    } catch (e) {
      console.log("connect PulseInteractive e", e);
      return Promise.reject("connect PulseInteractive e: " + e);
    }
  }

  async getBatteryCharacteristic() {
    this.statusChar = await this.sensorService.getCharacteristic(
      statusCharacteristicUuid
    );
  }

  async write(percent) {
    const value = Math.max(0, Math.min(99, Math.round(percent)));
    const array = new Uint8Array([0x01, Math.floor(value / 10)]);
    console.log(array);
    await this.motorChar.writeValue(array);
  }

  async getBattery() {
    const data = await this.statusChar?.readValue();
    return data?.getUint8(5);
  }
}
